
import React, {FC} from 'react';
import classNames from 'classnames';
import {ReportSpinner} from 'components/ReportModal/ReportSpinner';
import {Environment, isEnvironment} from 'creates/env';

import * as styles from './styles.module.scss';

const isProd = isEnvironment(Environment.PRODUCTION);

type ReportProps = {
	cache: string
}

export const ReportIframe: FC<ReportProps> = ({cache}) => {
	if (!isProd) {
		return (
			<ReportSpinner>
				<h1>This is a development build</h1>
				<p>Report review is not supported</p>
			</ReportSpinner>
		);
	}

	if (!cache) {
		return <ReportSpinner />;
	}

	return (
		<div className={classNames(styles.shared, styles.iframe)}>
			<iframe src={`/iframe-dexa/${cache}`} />
		</div>
	);
};
